import React, {useState} from "react";
import {Button} from "antd";
import "../mythPASSModal/passModal.less";
import {Web3Store} from "../../stores/web3Store";
import {IAction, IServerMythPass} from "../../bean/ResponseBean";
import {MythServerResultCode} from "../../constant/CommonConstant";
import logger from "../../logger";
import RegisterWithMythPASS from "../registerWithMythPASS";

interface IProps {
    web3Store: Web3Store,
    activeMenu: IAction,
    isGolden?:boolean,
    actionJoinedPass:number[],
    quantity:number,
    onApplySuccessfully:(activeMenu: IAction) => void,
    btnDisabled:boolean,
    btnContent:string
}
export const ApplyForFreeMintBtn = ({web3Store, activeMenu, isGolden,actionJoinedPass,quantity,onApplySuccessfully,btnDisabled,btnContent}: IProps) => {
    let [visible, setVisible] = useState(false);
    let [loading, setLoading] = useState(false);
    let [unLockedPasses, setAllUnLockedPasses] = useState<IServerMythPass[]>();
    const clickButton = () => {
        setLoading(true)
        try{
            getMythPassAvailable().then(passTokenIds => {
                if (web3Store.mythServerApi && web3Store.account) {
                    web3Store.mythServerApi.getPassStatus(passTokenIds?passTokenIds:[], web3Store.account).then(response => {
                        if (response && response.resultCode === MythServerResultCode.SUCCESS) {
                            /*response.resultValue.allPass = [{id:"1",rarity:2,isLocked:1},
                                {id:"2",rarity:2,isLocked:0},
                                {id:"3",rarity:1,isLocked:1},
                                {id:"4",rarity:1,isLocked:1},
                                {id:"5",rarity:1,isLocked:1},
                                {id:"6",rarity:2,isLocked:0}]*/
                            const unLockedPasses:IServerMythPass[] = response.resultValue.allPass.filter(item => item.isLocked === 0)
                            setAllUnLockedPasses(unLockedPasses)
                            setVisible(true);
                            setLoading(false);
                        }
                    }).catch(reason => {
                        logger.error(reason)
                        setLoading(false)
                    });
                }
            }).catch(reason => {
                logger.error(reason)
                setLoading(false)
            });
        }catch (e) {
            logger.error(e)
            setLoading(false)
        }
    }

    const getMythPassAvailable =async ()=> {
        try {
            if (web3Store.mythGraphApi && web3Store.account) {
                const mythPasses = await web3Store.mythGraphApi.fetchMythPass(web3Store.account);
                return mythPasses.classicPassTokenIds.concat(mythPasses.goldenPassTokenIds);
            }
        } catch (ex) {
            setLoading(false)
            logger.error(ex);
        }
    }

    const onStepModalCancel=(reload:boolean)=>{
        setVisible(false)
        if(reload){
            onApplySuccessfully(activeMenu);
        }
    }
    return <>
        <Button className='myth-button myth-button-success' style={{width:"5.5rem"}} disabled={btnDisabled} onClick={clickButton} loading={loading}>{btnContent}</Button>
        {visible &&
        //<StepModal actionJoinedPass={actionJoinedPass} visible={visible} allPasses={allPasses?allPasses:[]} web3Store={web3Store} isGolden={isGolden} activeMenu={activeMenu} onCancel={onStepModalCancel} quantity={quantity} infoList={getList()}/>
        <RegisterWithMythPASS  visible={visible}  web3Store={web3Store} onCancel={onStepModalCancel} passList={unLockedPasses?unLockedPasses:[]} actionJoinedPass={actionJoinedPass} activeMenu={activeMenu} />
       }
    </>
}
